import { processHtmlAttributes } from "../../common/html-attributes/index.js";
static function noop() {}
$ const {
  class: inputClass,
  style,
  ...htmlInput
} = input;
$ input.toJSON = noop;
<span class=["switch", inputClass] style=style>
  <input ...processHtmlAttributes(htmlInput) onChange("handleChange") type="checkbox" role="switch" class="switch__control">
  <span class="switch__button"/>
</span>